import React, { Component } from 'react';
import {
    createFragmentContainer,
    graphql,
} from 'react-relay';

import {
    Table,
    TableBody,
    TableRow,
    TableHeader,
    TableHeaderColumn,
} from 'material-ui/Table';

import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import { withRouter } from 'react-router-dom';
import PeopleListItem from './PeopleListItem';

const fabStyle = {
    margin: 0,
    top: 100,
    right: 80,
    left: 'auto',
    position: 'fixed',
};

const personTypes = [
    { id: 'host', text: 'Ведущий' },
    { id: 'author', text: 'Автор' },
    { id: 'person', text: 'Персоналия' },
    { id: 'admin', text: 'Админ' },
];

export class PeopleList extends Component {
	state = {
		open: false,
		anchorEl: null,
	};

    static onSearchPressed(text) {
        alert(`we want to search for ${text}`);
    }

    onFABClick = (event) => {
        event.preventDefault();

        this.setState({
            open: true,
            anchorEl: event.currentTarget,
        });
    };

    onFABClose = () => {
        this.setState({ open: false });
    };

    renderPeople() {
        if (this.props.viewer.persons.edges.length === 0) {
            return (<tr><td><div><center>Здесь пока пусто</center></div></td></tr>);
        }

        return this.props.viewer.persons.edges.map(edge => (
            <PeopleListItem
                key={edge.node.id}
                person={edge.node}
                router={this.props.router}
                viewer={this.props.viewer}
            />
        ));
    }

    render() {
        return (
            <Paper style={{ padding: 16 }}>
                <h4>Персоны</h4>
                <Table>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            <TableHeaderColumn>Тип</TableHeaderColumn>
                            <TableHeaderColumn colSpan="5">Имя</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody showRowHover stripedRows>
                        {this.renderPeople()}
                    </TableBody>
                </Table>

                <RaisedButton
                    label="СОЗДАТЬ ПЕРСОНУ"
                    primary
                    style={fabStyle}
                    onClick={this.onFABClick}
                />
                <Popover
                    open={this.state.open}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                    onRequestClose={this.onFABClose}
                >
                    <Menu>
                        {personTypes.map(personType => (
                            <MenuItem
                                key={personType.id}
                                primaryText={personType.text}
                                onClick={() => this.props.history.push(`/new_person/${personType.id}`)}
                            />
                        ))}
                    </Menu>
                </Popover>
            </Paper>);
    }
}

export default withRouter(createFragmentContainer(
    PeopleList,
    graphql`
        fragment PeopleList_viewer on Viewer {
            persons(first: -1) {
                edges {
                    node {
                        id,
                        ...PeopleListItem_person
                    }
                }
            }
        }
    `,
));



// WEBPACK FOOTER //
// src/components/PeopleList.js